import { render, staticRenderFns } from "./CertificatesEdit.vue?vue&type=template&id=04de315c&"
import script from "./CertificatesEdit.vue?vue&type=script&lang=js&"
export * from "./CertificatesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports